<template>
  <v-dialog scrollable persistent v-model="dialog" max-width="600px">
    <template v-slot:activator="{ on }">
      <v-tooltip left v-on="on">
        <template v-slot:activator="{ on }">
          <v-btn
            v-if="showButton"
            v-on="on"
            dark
            small
            fab
            color="primary"
            @click="openForm()"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <span>Concluir serviço</span>
      </v-tooltip>
    </template>

    <v-card>
      <v-system-bar color="primary" dark>
        <v-spacer></v-spacer>
        <v-icon color="#fff" @click="closeForm">close</v-icon>
      </v-system-bar>

      <v-card-title class="mb-4 pb-0">
        <span class="title grey--text text--darken-2">
          Concluir serviço
        </span>
      </v-card-title>

      <v-card-text class="mt-0 pt-0">
        <v-form
          ref="confirmJobForm"
          v-model="validForm"
          lazy-validation
          class="mt-0 pt-0"
        >
          <v-layout row wrap>
            <v-flex xs12>
              <v-menu
                v-model="valDate"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :disabled="true"
                    v-model="end_date_formated"
                    label="Data fim"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    return-masked-value
                    mask="##/##/####"
                    :rules="$store.state.formRules.required"
                    required
                  ></v-text-field>
                </template>
                <v-date-picker
                  no-title
                  v-model="formData.end_date"
                  @input="valDate = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs12>
              <v-textarea
                v-model="formData.description_solution"
                label="Descrição"
                :rules="$store.state.formRules.required"
                required
                maxlength="1000"
              ></v-textarea>  
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>

      <v-card-actions style="border-top: 1px solid #eee">
        <v-spacer></v-spacer>
        <v-btn color="blueGrey darken-1" flat @click="closeForm"
          >Cancelar</v-btn
        >
        <v-btn v-if="!viewForm" color="primary" flat @click="doSave"
          >Salvar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import * as moment from 'moment'

const defaultJOpenJob = () => {
  return {
    end_date: new Date().toISOString().substr(0, 10),
    description_solution: "",
  }
}

export default {
  name: 'ConfirmJobDlg',

  props: {
    showButton: Boolean,
    dialog: Boolean,
    openForm: Function,
    closeForm: Function,
    jobId: Number,
    jobIndex: Number,
  },

  data () {
    return {
      valDate: false,
      viewForm: false,
      validForm: true,
      formData: defaultJOpenJob(),
    }
  },

  computed: {
    end_date_formated: {
      get () {
        return this.formData.end_date
          ? moment(this.formData.end_date).format('DD/MM/YYYY')
          : ''
      },
      set (value) {
        if (value) {
          if (value.length < 10) return
          let arrs = value.split('/')
          let date = `${arrs[2]}-${arrs[1]}-${arrs[0]}`
          if (!moment(date).isValid()) {
            this.formData.end_date = new Date().toISOString().substr(0, 10)
            return
          }
          this.formData.end_date = date
        } else {
          this.formData.end_date = ''
        }
      }
    },
  },

  watch: {
    dialog (edit) {   
      if (edit) {
        // do something
      } else {
        this.formData = defaultJOpenJob()
        this.viewForm = false
      }
    }
  },

  methods: {
    doSave () {
      if (!this.$refs.confirmJobForm.validate()) {
        return
      }

      this.$emit('jobConcluded', { jobId: this.jobId, jobIndex: this.jobIndex, data: this.formData })

      this.$refs.confirmJobForm.resetValidation()

      this.closeForm()
    },

    resetDialog () {
      this.dialogShow = !this.dialogShow
    }
  }
}
</script>
